// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3leF7","tab":"Tabs_tab__1wvaM","tabActive":"Tabs_tabActive__GL_zr"};